import { handleActions, createAction } from 'redux-actions';
import pick from 'lodash/pick';
import { cloneDeep } from 'lodash';

export const FETCH_DESIGN = createAction('FETCH/DESIGN');
export const FETCH_DESIGN_SUCCESS = createAction('FETCH/DESIGN/SUCCESS');
export const FETCH_DESIGN_FAIL = createAction('FETCH/DESIGN/FAIL');
export const CHANGE_DESIGN = createAction('CHANGE/DESIGN');
export const CHANGE_DESIGN_SUCCESS = createAction('CHANGE/DESIGN/SUCCESS');
export const CHANGE_DESIGN_FAIL = createAction('CHANGE/DESIGN/FAIL');

const initialState = {
  id: '',
  logo: '',
  subdomain: '',
  header_title: '',
  header_slogan: '',
  header_description: '',
};

const designReducer = handleActions(
  {
    [FETCH_DESIGN_SUCCESS]: (state, { payload: data, }) => {
      const newData = pick(data, ['id', 'header_title', 'header_description', 'header_slogan', 'logo', 'subdomain']);
      return { ...state, ...newData, logo: data.logo_url, };
    },
    [FETCH_DESIGN_FAIL]: (state, { payload: { error, }, }) => {
      const newState = cloneDeep(state);
      newState.fetchDesignErrors = error;
      return newState;
    },
    [CHANGE_DESIGN_SUCCESS]: (state, { payload: { data, }, }) => {
      const newData = pick(data, ['id', 'header_title', 'header_description', 'header_slogan', 'logo', 'subdomain']);

      return { ...state, ...newData, logo: data.logo_url, };
    },
  },
  initialState
);

export default designReducer;
